import React from "react";
import { useMap } from "react-leaflet";
import icon from "../../../assets/center.png";

interface props {
  x: number | undefined;
  y: number | undefined;
}

const CenterPositionButton: React.FC<props> = ({ x, y }) => {
  const map = useMap();

  const goToCenter = () => {
    if (x && y) map.flyTo([y, x]);
  };

  return (
    <button
      className="w-14 h-14 bottom-3 right-3 z-[1000] rounded-full text-white bg-black absolute border-2 border-white p-1"
      onClick={goToCenter}
    >
      <img src={icon}></img>
    </button>
  );
};

export default CenterPositionButton;
